import { SignIn } from 'components/SignIn';
import React from 'react';
import { useAuthUser } from './AuthUserProvider';


type Props = {
    children: React.ReactNode
}

export function EnsureSignedIn({ children }: Props) {
    const [authUser, loading] = useAuthUser()

    if (!authUser && !loading) {
        return <SignIn />
    }

    return <>{children}</>
}